export class DocumentNotFoundError extends Error {
  constructor(msg = 'Document not found') {
    super(msg)
    this.name = 'DocumentNotFoundError'
  }
}

// Firestore buffers writes while offline: the returned promise neither resolves
// nor rejects until the backend acknowledges. We race writes against a timeout
// and raise this so callers get error feedback instead of a stuck spinner. It
// carries the 'unavailable' code so error normalization maps it to the standard
// connection message — the backend was effectively unreachable.
export class WriteTimeoutError extends Error {
  readonly code = 'unavailable'

  constructor(msg = 'The request could not be completed') {
    super(msg)
    this.name = 'WriteTimeoutError'
  }
}

// Raised INSTEAD of issuing a write, when the backend was found unreachable
// first. Bounding a write is not enough on its own: the Firestore client keeps
// a timed-out write queued and commits it on reconnect, so the user is told it
// failed and then sees it land anyway. A write never issued cannot do that.
// Carries the same 'unavailable' code, so callers word it as a connection
// problem without knowing which of the two happened.
export class BackendUnreachableError extends Error {
  readonly code = 'unavailable'

  constructor(msg = 'No connection to the server') {
    super(msg)
    this.name = 'BackendUnreachableError'
  }
}
